export function isBoolean(obj: unknown): boolean {
  // typeof and string comparisons are slow
  return (
    obj === true || obj === false || toString.call(obj) === '[object Boolean]'
  )
}
